import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/pages/HomePage.vue'),
    },
    {
      path: '/studio',
      name: 'studio',
      component: () => import('@/pages/StudioPage.vue'),
    },
    {
      path: '/firing',
      name: 'firing',
      component: () => import('@/pages/FiringPage.vue'),
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: () => import('@/pages/GalleryPage.vue'),
    },
    {
      path: '/showcase',
      name: 'showcase',
      component: () => import('@/pages/ShowcasePage.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
  scrollBehavior: () => ({ top: 0 }),
})
